import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MessageService } from 'primeng/api';
import { UrlRequest } from '../Models/AgencyMasterProperties';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { SuppliersCurrency } from '../Models/OfflineBookingRequestProperties';
import { OfflineSupplierOfficeProperties, OfflineSupplierProperties } from '../Models/OfflineSupplierProperties';
import { OfflinesuppliersService } from '../Services/offlinesuppliers.service';
import { SuppliersService } from '../Services/suppliers.service';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-offline-supplier',
    templateUrl: './offline-supplier.component.html',
    styleUrls: ['./offline-supplier.component.css'],
    imports: [Bind, Toast, NavMenuComponent, FormsModule, NgClass, ToggleSwitch, Select, RouterLink]
})
export class OfflineSupplierComponent {
  offlineSuppliersDetails = new OfflineSupplierProperties();
  offlineSupplierPccDetails : OfflineSupplierOfficeProperties[]=[];
  namebutton: string = "";
  formSubmit: boolean = false;
  update: boolean = false;
  officeid: string = "";
  agencyid: string = "";
  userId: string = "";
  isSaved: boolean;
  loader: boolean=false;
  accessCodeArray = [];
  companyMasterList: CompanyMasterProperties[] = [];
  constructor(private service: SuppliersService,private offlineSupplierservice: OfflinesuppliersService, private messageservice: MessageService, private router: Router) { }

  ngOnInit() {
    let offlineSupplierId = localStorage.getItem("OffSupplierId");
    let typeCheck = localStorage.getItem("TypeCheck");
     this.agencyid = localStorage.getItem("AgencyId");
    this.userId = localStorage.getItem("UserId");

    this.GetCompanyMaster();
    this.GetSupplierCurrencies();
    if (typeCheck == "Create") {
      this.offlineSupplierPccDetails = [];
      let obj = new OfflineSupplierOfficeProperties();
      this.offlineSupplierPccDetails.push(obj);
      this.namebutton = "Create";

    }
    else if (typeCheck == "Update") {
      this.loader = true;
      this.namebutton = "Update";
      this.offlineSupplierservice.GetOfflineSupplierByID(offlineSupplierId).subscribe((data) => {
        this.offlineSuppliersDetails = data;
        this.offlineSupplierPccDetails = this.offlineSuppliersDetails.officeSupplierList;
        this.update = true;
        for (let y = 0; y < this.offlineSupplierPccDetails.length; y++) {
          this.GetBackSystemSupplier(y);

        }
        this.loader = false;
      })
    }
  }
  SubmitData = (roeForm: any): boolean => {
    this.formSubmit = true;
    if (roeForm.invalid) {
      this.messageservice.add({ severity: 'error', summary: 'Required', detail: 'Fields are Required' });
      return false;
    }
    this.loader = true;
    if (this.update) {
      this.offlineSuppliersDetails.userId = this.userId;
      this.offlineSuppliersDetails.agencyId = this.agencyid;
      this.offlineSuppliersDetails.officeSupplierList = this.offlineSupplierPccDetails;
      this.offlineSupplierservice.UpdateOfflineSupplier(this.offlineSuppliersDetails).subscribe((data) => {
        if (data.isSaved) {
          this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully!' });
          this.router.navigateByUrl("/offlineSupplierList");

        }
        else {
          this.messageservice.add({ severity: 'error', summary: 'Error' });
        }
        this.loader = false;
      });
    }


    else {
        this.offlineSuppliersDetails.userId = this.userId;
      this.offlineSuppliersDetails.agencyId = this.agencyid;
      this.offlineSuppliersDetails.officeSupplierList = this.offlineSupplierPccDetails;
      this.offlineSupplierservice.CreateOfflineSupplier(this.offlineSuppliersDetails).subscribe((data) => {
        if (data.isSaved) {
          this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully!' });
          this.router.navigateByUrl("/offlineSupplierList");
        }
        else {
          this.messageservice.add({ severity: 'error', summary: 'Error' });
        }
        this.loader = false;
      });
    }
  }

  AddSupplierOffice() {
      let listObj = new OfflineSupplierOfficeProperties();
    this.offlineSupplierPccDetails.push(listObj);
      
    

  }


  deleteairline(index: number) {
   
    this.offlineSupplierPccDetails.splice(index, 1);
  }
  GetCompanyMaster() {
    this.service.GetCompanyMaster().subscribe(data => {
      this.companyMasterList = data;

    })
  }
  suppliersCurrencyList: SuppliersCurrency[] = [];
  private GetSupplierCurrencies = (): void => {
    this.service.GetSupplierCurrencies().subscribe(data => {
      this.suppliersCurrencyList = data;
    });
  }
  GetBackSystemSupplier = (index): void => {
    this.loader = true;
    let companyId = Number(this.offlineSupplierPccDetails[index].backOfficeCompany);
    if (companyId != 0 && companyId != null && companyId != undefined) {
      let companyURL = "";
      for (let i = 0; i < this.companyMasterList.length; i++) {
        if (companyId== this.companyMasterList[i].companyId) {
          companyURL = this.companyMasterList[i].companyURL;
          break;
        }

      }
      var req = new UrlRequest();
      req.request = companyURL;
      this.service.GetSupplierCodeByID(req).subscribe((data) => {
        this.offlineSupplierPccDetails[index].supplierCodesList = data
        this.loader = false;
      });

    }


  }

}
